import * as React from 'react';
import { Add, RemoveRedEye } from '@mui/icons-material';
import { Typography, Button } from '@mui/material';
import { Box } from '@mui/system';

import { SubscriptionEventKeys, SubscriptionEvents } from '../events';
import { Subscription } from '@/shared/i18n';

import { FormCard, SubmitButton } from '../../ui/shared';
import SubscriptionCard from './elements/subscription-card';
import { EventBus } from '@/shared/utils';
import SubscriptionsDialog from './elements/subscription-modal';

interface SubscriptionFormProps {
  eventBus: EventBus<SubscriptionEvents>;
  dict: Subscription;
}

const SubscriptionForm: React.FC<SubscriptionFormProps> = ({ eventBus, dict }) => (
  <>
    <Box sx={{ mt: 2 }}>
      <FormCard title={dict.subscriptions.card_subscription_title}>
        <SubscriptionCard eventBus={eventBus} dict={dict} />
      </FormCard>
    </Box>

    {/* <FormCard title={dict.subscriptions.payment_method}>
      <div className="flex flex-wrap justify-between w-full gap-4">
        <div className="flex-1">
          <Typography variant="s1" component="p" color="textSecondary">
            {dict.subscriptions.cards}
          </Typography>
          <Typography variant="body-500" component="p">
            {dict.subscriptions.no_card}
          </Typography>
        </div>
        <Button variant="outlined" color="primary" size="medium" className="gap-1 w-full sm:w-auto">
          <Add className="h-[16px] hidden md:block" />
          <Typography variant="button-m">{dict.subscriptions.add_payment_method}</Typography>
        </Button>
      </div>
    </FormCard> */}

    <FormCard title={dict.subscriptions.transactions_history}>
      <div className="flex flex-col gap-4">
        <div className="space-y-2">
          <Typography variant="body-500">{dict.subscriptions.transactions_history_body}</Typography>
        </div>
        <div>
          <Button
            variant="outlined"
            color="primary"
            size="medium"
            className="gap-1 w-full sm:w-auto"
            onClick={() => eventBus.emit(SubscriptionEventKeys.payment.openPortal.do, undefined)}
          >
            <RemoveRedEye className="h-[16px] hidden md:block" />
            <Typography variant="button-m">{dict.subscriptions.transactions_list}</Typography>
          </Button>
        </div>
      </div>
    </FormCard>

    {/* Submit Button */}
    {/* <SubmitButton buttonText={dict.subscriptions.save_changes} isDisabled /> */}

    {/* Dialog for Cambia Piano */}
    <SubscriptionsDialog eventBus={eventBus} dict={dict} />
  </>
);

export { SubscriptionForm };
